import React from 'react';
import { Skeleton } from '../../Skeleton';

const PopularSpecialityLoader = ({ title }) => {
  return (
    <>
      <div className="w-100 shadow bg-white rounded-3 specialitiesBox">
        <div className="d-flex align-items-baseline justify-content-between mb-4">
          <h2 className="text-black fs-2 fw-medium">
            <span className="text-secondary">{title?.split(' ')[0]}</span>{' '}
            {title?.slice(title?.split(' ')[0].length, title?.length ?? 0)}
          </h2>
          <a href="javascript:void(0)" className="text-primary d-inline-block">
            Explore More
          </a>
        </div>
        <ul className="specialitiesList mt-2">
          <li>
            <Skeleton variant="text" width="100%" height="100%" />
          </li>
          <li>
            <Skeleton variant="text" width="100%" height="100%" />
          </li>
          <li>
            <Skeleton variant="text" width="100%" height="100%" />
          </li>
          <li>
            <Skeleton variant="text" width="100%" height="100%" />
          </li>
          <li>
            <Skeleton variant="text" width="100%" height="100%" />
          </li>
          <li>
            <Skeleton variant="text" width="100%" height="100%" />
          </li>
          <li>
            <Skeleton variant="text" width="100%" height="100%" />
          </li>
          <li>
            <Skeleton variant="text" width="100%" height="100%" />
          </li>
          <li>
            <Skeleton variant="text" width="100%" height="100%" />
          </li>
          <li>
            <Skeleton variant="text" width="100%" height="100%" />
          </li>
          <li>
            <Skeleton variant="text" width="100%" height="100%" />
          </li>
          <li>
            <Skeleton variant="text" width="100%" height="100%" />
          </li>
          <li>
            <Skeleton variant="text" width="100%" height="100%" />
          </li>
        </ul>
      </div>
    </>
  );
};

export default PopularSpecialityLoader;
